﻿import React from 'react';
import ReactModal from 'react-modal';
import * as VeilederLogikk from './Veileder';
import GResultatContainer from './Components/G-ResultatComponent';
import GxResultatContainer from './Components/GX-ResultatComponent';
import HResultatContainer from './Components/I-ResultatComponent';
import IResultatContainer from './Components/GU-ResultatComponent';
import DArstimerProsentContainer from './Components/D-ArstimerProsentComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import NumberInputStegContainer, { NumberFormatter } from '../Shared/Scripts/Components/NumberInputStegComponent';
import { tilPengerFormat, fraPengerFormat } from '../Shared/Scripts/Utilities/Formatters';
import A from './Utilities/A-StudieretningValg';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import B from './Utilities/B-VarighetValg';
import H from './Utilities/H-BostedValg';
import E from './Utilities/E-SkolepengerValg';
import D from './Utilities/D-ArstimerProsent';
import * as ValgTypes from './Store/Valg/Types';
import VeilederVgsUrDto from './Models/VeilederVgsUrDto';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { VeilederVgsUtenUrAppState } from './Store';
import { connect } from 'react-redux';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { ResultatValg, ResultatValgValidering } from './Store/Resultat/Types';
import * as Validering from './Utilities/ValideringParameters';
import * as Ids from './Ids';
import contentResolver, { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { ValideringsResultat } from '../Shared/Scripts/Models/ValideringsResultat';
import { updateValidation } from './Store/Resultat/Actions';
import { Satser } from './Utilities/SatserApi';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import CFulltidDeltidValg from './Utilities/C-FulltidDeltidValg';
import { NumberInputType } from './Components/D-ArstimerProsentComponent';
import { ArstimerProsentValg } from './Models/ArstimerProsentValg';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederVgsUrDto>();
const NumberInputStegComponent = NumberInputStegContainer<VeilederVgsUrDto>();
const DArstimerProsentComponent = DArstimerProsentContainer<VeilederVgsUrDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false, fullfortDel2: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, dispatchUpdateValidering, epiContext, satser } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        if (resultat.visGenerellFeil || epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            let resultatElement: JSX.Element | undefined;
            let fordelingResultat: JSX.Element | undefined;
            let utbetalingsPlanElement: JSX.Element | undefined;
            let delvisResultatElement: JSX.Element | undefined;

            if (satser != null) {
                let stipendOgLan;

                if (resultat.visResultat) {
                    stipendOgLan = VeilederLogikk.beregnStipendOgLan(valg, satser);
                    const utbetalingsplan = VeilederLogikk.utbetalingsplan(valg, stipendOgLan, satser);
                    if (valg.visUtbetalingsplan) {
                        utbetalingsPlanElement = <IResultatContainer utbetalingsplan={utbetalingsplan} />;
                    }

                    resultatElement = (
                        <GResultatContainer
                            idA={valg.aStudieretning?.value}
                            idB={valg.bVarighet?.value}
                            verdiF={resultat.visBoksF ? valg.fSpBelop || 0 : 0}
                            resultat={stipendOgLan}
                            utbetalingsplan={utbetalingsplan}
                            eventId={eventId}
                        />
                    );
                } else if (resultat.visDelvisResultat) {
                    const basisstotte = VeilederLogikk.beregnStipendDelvis(valg, satser);
                    const skolepengeLan = VeilederLogikk.maksSkolepenger(valg, satser);
                    stipendOgLan = basisstotte + skolepengeLan;

                    delvisResultatElement = (
                        <GxResultatContainer basisstotte={basisstotte} skolepengelan={skolepengeLan} eventId={eventId} />
                    );
                }

                if (resultat.visFordeling && stipendOgLan) {
                    const andelStipendOgLan = VeilederLogikk.beregnAndelStipendOgLan(valg, stipendOgLan, satser);
                    fordelingResultat = (
                        <HResultatContainer verdiD={valg.hBosted?.value} resultat={andelStipendOgLan} eventId={eventId} />
                    );
                }
            }

            function registerEvents(): void {
                if (!analyticsState.startet) {
                    if (resultat.visBoksB) {
                        analyticsState.startet = true;
                        registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                    }
                }

                if (!analyticsState.fullfort) {
                    if (resultat.visResultat) {
                        analyticsState.fullfort = true;
                        registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                    }
                }

                if(!analyticsState.fullfortDel2) {
                    if(resultat.visFordeling) {
                        analyticsState.fullfortDel2 = true;
                        registerAnalyticsEvent({ action: 'VeilederFerdigDel2', eventId });
                    }
                }
            }

            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelStudieretning')}
                        forklaring={contentResolver(epiContext, 'brodtekstStudieretning')}
                        sporsmal="ledetekstStudieretning"
                        valg={A.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aStudieretning: nyttValg });
                        }}
                        neverCollapse={true}
                        classModifier="c-veileder__panel--input-white"
                        value={valg.aStudieretning}
                    />
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'tittelVarighet')}
                            forklaring={contentResolver(epiContext, 'brodtekstVarighet')}
                            sporsmal="ledetekstVarighet"
                            valg={B.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bVarighet: nyttValg });
                            }}
                            value={valg.bVarighet}
                        />
                    )}
                    {resultat.visBoksC && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksC}
                            tittel={contentResolver(epiContext, 'tittelFulltidDeltid')}
                            forklaring={contentResolver(epiContext, 'brodtekstFulltidDeltid')}
                            sporsmal="ledetekstFulltidDeltid"
                            valg={CFulltidDeltidValg.cValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cFulltidDeltid: nyttValg });
                            }}
                            value={valg.cFulltidDeltid}
                        />
                    )}
                    {resultat.visBoksD &&
                        this.arstimerProsentBoks(
                            valg,
                            resultat,
                            locale,
                            dispatchUpdateValg,
                            dispatchUpdateValidering,
                            epiContext,
                        )}
                    {resultat.visBoksE && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksE}
                            tittel={contentResolver(epiContext, 'tittelSkolepenger')}
                            forklaring={contentResolver(epiContext, 'brodtekstSkolepenger')}
                            sporsmal="ledetekstSkolepenger"
                            valg={E.eValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ eSkolepenger: nyttValg });
                            }}
                            value={valg.eSkolepenger}
                        />
                    )}
                    {resultat.visBoksF &&
                        satser != null &&
                        this.skolepengerBoks(
                            valg,
                            resultat,
                            locale,
                            dispatchUpdateValg,
                            dispatchUpdateValidering,
                            epiContext,
                            satser,
                            valuta,
                        )}
                    {resultatElement}
                    {utbetalingsPlanElement}
                    {delvisResultatElement}
                    {(resultat.visResultat || resultat.visDelvisResultat) && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksH}
                            tittel={contentResolver(epiContext, 'tittelBosituasjon')}
                            forklaring={contentResolver(epiContext, 'brodtekstBosituasjon')}
                            sporsmal="ledetekstBosituasjon"
                            valg={H.hValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ hBosted: nyttValg });
                            }}
                            value={valg.hBosted}
                            classModifier="c-veileder__panel--input-white"
                            neverCollapse={true}
                        />
                    )}
                    {fordelingResultat}
                </div>
            );
        } else {
            return <p>Laster...</p>;
        }
    }

    private skolepengerBoks(
        valg: ValgTypes.ValgState,
        resultat: ResultatValg,
        locale: string,
        dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void,
        dispatchUpdateValidering: (result: Partial<ResultatValgValidering>) => void,
        epiContext: EpiContext<VeilederVgsUrDto>,
        satser: Satser,
        valuta: string,
    ): React.ReactNode {
        const maxSkolepenger = VeilederLogikk.maksSkolepenger(valg, satser);
        const maxskolepengerFormatert = `${tilPengerFormat(maxSkolepenger, locale)}&nbsp;${valuta}`;
        const map = new Map<string, string>();
        map.set('${maxBelop}', maxskolepengerFormatert);

        const formatter: NumberFormatter = {
            toFormattetString: (v: number): string => tilPengerFormat(v, locale),
            toParsableAsNumber: (v: string): string => fraPengerFormat(v, locale),
        };

        return (
            <NumberInputStegComponent
                sporsmalId={Ids.BoksF}
                sporsmal="ledetekstSkolepengerBelop"
                tittel={contentResolver(epiContext, 'tittelSkolepengerBelop')}
                forklaring={contentResolver(epiContext, 'brodtekstSkolepengerBelop', 1, map)}
                inputId="f1"
                placeholder={resolveRawText(epiContext, 'placeholderSkolepengerBelop')}
                decimals={0}
                value={valg.fSpBelop}
                postfix={valuta}
                ctaText="ctaSkolepengerBelop"
                validering={Validering.fSkolepengerValidering(maxSkolepenger, locale)}
                numberDisplayFormatter={formatter}
                onInputChange={(nyttValg: number | undefined): void => {
                    dispatchUpdateValg({ fSpBelop: nyttValg });
                }}
                onValidationChanged={(result: ValideringsResultat | undefined): void =>
                    dispatchUpdateValidering({ fValidation: result })
                }
                preValidation={resultat.fValidation}
                validationChecksum={maxSkolepenger}
            />
        );
    }

    private arstimerProsentBoks(
        valg: ValgTypes.ValgState,
        resultat: ResultatValg,
        locale: string,
        dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void,
        dispatchUpdateValidering: (result: Partial<ResultatValgValidering>) => void,
        epiContext: EpiContext<VeilederVgsUrDto>,
    ): React.ReactNode {
        const fulltid = VeilederLogikk.fulltidArstimer(valg);
        const maksVerdi = VeilederLogikk.finnMaksArstimer(valg, fulltid);

        const inputTypes: NumberInputType<VeilederVgsUrDto>[] = [
            {
                inputTypeId: D.d1_arstimer,
                inputTypeLabel: resolveRawText(epiContext, 'valgArstimer'),
                placeholder: resolveRawText(epiContext, 'placeholderArstimerProsent'),
                validering: Validering.dArstimerValidering(maksVerdi),
                preValidation: valg.dArstimerProsent?.type === D.d1_arstimer ? resultat.dValidation : undefined,
            },
            {
                inputTypeId: D.d2_prosent,
                inputTypeLabel: resolveRawText(epiContext, 'valgProsent'),
                placeholder: resolveRawText(epiContext, 'placeholderArstimerProsent'),
                validering: Validering.dProsentValidering,
                preValidation: valg.dArstimerProsent?.type === D.d2_prosent ? resultat.dValidation : undefined,
            },
        ];

        return (
            <DArstimerProsentComponent
                sporsmalId={Ids.BoksD}
                sporsmal="ledetekstArstimerProsent"
                tittel={contentResolver(epiContext, 'tittelArstimerProsent')}
                forklaring={contentResolver(epiContext, 'brodtekstArstimerProsent')}
                inputId="d1"
                decimals={0}
                value={valg.dArstimerProsent?.verdi}
                ctaText="ctaArstimerProsent"
                inputTypes={inputTypes}
                onInputChange={(nyttValg: ArstimerProsentValg | undefined): void => {
                    dispatchUpdateValg({ dArstimerProsent: nyttValg });
                }}
                onValidationChanged={(result: ValideringsResultat | undefined): void =>
                    dispatchUpdateValidering({ dValidation: result })
                }
                vetIkke={valg.dArstimerProsent?.vetIkke ?? false}
                vetIkkeLabel={resolveRawText(epiContext, 'vetIkkeArstimerProsent')}
                selectLabel={resolveRawText(epiContext, 'dropdownLabelArstimerProsent')}
            />
        );
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederVgsUrDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederVgsUtenUrAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>): void => {
        dispatch(updateValidation(validation));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederVgsUtenUrAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
